import React, { useEffect, useState } from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import { TListingClient } from 'types/TListing';

type TSimilarAsqItems = {
  similar: TListingClient[];
  feed: TListingClient[];
  search: TListingClient[];
};

type TSimilarAsqAppAppProps = {
  appState: {
    listing: TListingClient;
    similarAsqItems?: TSimilarAsqItems;
  };
  environment: any;
};

const DEFAULT_SIMILAR_ASQ_ITEMS: TSimilarAsqItems = {
  similar: [],
  feed: [],
  search: [],
};

let SimilarAsq: React.ComponentType<{ items: TSimilarAsqItems; mainListing: TListingClient }>;

const SimilarAsqApp = ({ appState, environment }: TSimilarAsqAppAppProps) => {
  const { listing, similarAsqItems = DEFAULT_SIMILAR_ASQ_ITEMS } = appState;
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        SimilarAsq = (await import(/* webpackChunkName: "similarAsq" */ './components/SimilarAsq')).default;
        setIsLoaded(true);
      } catch {
        setLoadError(true);
      }
    })();
  }, []);

  if (loadError) {
    return null;
  }

  return (
    <EnvironmentProvider value={environment}>
      <div className="SimilarAsqContainer hz-Page-section">
        {isLoaded && <SimilarAsq items={similarAsqItems} mainListing={listing} />}
      </div>
    </EnvironmentProvider>
  );
};

export default SimilarAsqApp;
